import { useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { GetTheatricalReleasesQuery, GetTheatricalReleasesQueryVariables } from '@/types/codegen-federation'
import { isDefined } from '@/utils/primitives/generics'
import { GET_THEATRICAL_RELEASES } from './queries'

export const useGetAllTheatricalReleases = () => {
  const result = useQuery<GetTheatricalReleasesQuery, GetTheatricalReleasesQueryVariables>(GET_THEATRICAL_RELEASES, {
    variables: { input: {} },
    errorPolicy: 'all',
  })

  return useMemo(() => {
    return {
      ...result,
      theatricalReleases: result.data?.theatricalReleases?.theatricalRelease?.filter(isDefined) || [],
    }
  }, [result])
}
